module.exports = __webpack_public_path__ + "static/media/co.42c7d834.webp";